import React from 'react';
import lendersLogo from '../../assets/images/lal-logo.png';
import dcomlogo from '../../assets/images/logo-debt.com-whitetext.png';
import lendersphoneScreen from '../../assets/images/mobile-screen-lenders.png';
import dcomphoneScreen from '../../assets/images/mobile-image-dcom.png';
import epicphoneScreen from '../../assets/images/epic-mobile-media-image.png'; 
import GoDaddyLogo from '../../assets/images/godaddySecure.png';
import BBBLogo from '../../assets/images/bbb-aplus-logo.png';
import UWayLogo from '../../assets/images/United-Way-logo.png';
import TPilotLogo from '../../assets/images/trustpilot-logo.png';
import epicLogo from '../../assets/images/epic-loans-logo-dark-bkg.svg';
//import epicLogo from '../../assets/images/epic-loans-logo-reversed.png';

const domainsList = ['debt.com', 'lendersandloans.com', 'localhost', 'loancomparison.epicloans.com'];
let currentDomain = 'defaultHostname';

const domain = window.location.hostname;

for (let i = 0; i < domainsList.length; i++) {
  if (domain.indexOf(domainsList[i]) !== -1) {
    currentDomain = domainsList[i];
    break;
  }
}

const isStagingUrl = domain.indexOf('staging') !== -1;

const variants = {
  'loancomparison.epicloans.com': {
    logo: epicLogo,
    logoLink: 'https://epicloans.com/',
    url: `https://${isStagingUrl ? 'staging.' : ''}epicloans.com`,
    company: 'Epic Loans.com',
    copyright: '© 2022 EpicLoans®, LLC. All Rights Reserved.',
    address: '6360 NW 5TH Way #302, Fort Lauderdale, Florida 33309 USA',
    phoneScreen: epicphoneScreen,
    credibility: [
      {
        id: 'GoDaddyLogo',
        logo: GoDaddyLogo,
        link:
          'https://seal.godaddy.com/verifySeal?sealID=VttdGalb6RNnHGweH1ZPwYmmYt3XSbYeXM2Jk90v88Poa2JxPmkvASdRAOnA',
        alt: 'Godaddy',
        target: '_blank',
        stylesClass: 'logo-styles'
      }
    ],
    themeColor: '#017138'
  },
  'lendersandloans.com': {
    logo: lendersLogo,
    logoLink: 'https://lendersandloans.com',
    url: `https://${isStagingUrl ? 'staging.' : ''}lendersandloans.com`,
    company: 'LendersandLoans.com',
    copyright: '© 2022 LendersandLoans.com®, LLC. All Rights Reserved.',
    address: '6360 NW 5TH Way #302, Fort Lauderdale, Florida 33309 USA',
    phoneScreen: lendersphoneScreen,
    credibility: [
      {
        id: 'GoDaddyLogo',
        logo: GoDaddyLogo,
        link:
          'https://seal.godaddy.com/verifySeal?sealID=VttdGalb6RNnHGweH1ZPwYmmYt3XSbYeXM2Jk90v88Poa2JxPmkvASdRAOnA',
        alt: 'Godaddy',
        target: '_blank',
        stylesClass: 'logo-styles'
      }
    ],
    themeColor: '#6da852'
  },
  localhost: {
    logo: dcomlogo,
    url: 'https://www.debt.com/?utm_source=loancomparison&utm_campaign=loancomparelogo',
    company: 'Debt.com',
    copyright: '© 2022 Debt.com, LLC. All Rights Reserved',
    address: '5769 W. Sunrise Blvd. Plantation, FL 33313',
    phoneScreen: dcomphoneScreen,
    credibility: [
      {
        id: 'BBBLogo',
        logo: BBBLogo,
        link:
          'https://www.bbb.org/us/fl/plantation/profile/credit-services/debtcom-llc-0633-90080459',
        alt: 'BBBLogo',
        target: '_blank',
        stylesClass: 'logo-styles'
      },
      { id: 'UWayLogo', logo: UWayLogo, link: '', alt: 'UWayLogo', target: '' },
      {
        id: 'GoDaddyLogo',
        logo: GoDaddyLogo,
        link:
          'https://seal.godaddy.com/verifySeal?sealID=VttdGalb6RNnHGweH1ZPwYmmYt3XSbYeXM2Jk90v88Poa2JxPmkvASdRAOnA',
        alt: 'Godaddy',
        target: '_blank',
        stylesClass: 'logo-styles'
      },
      {
        id: 'TPilotLogo',
        logo: TPilotLogo,
        link: 'https://www.debt.com/reviews/',
        alt: 'TPilotLogo',
        target: '_blank',
        stylesClass: 'logo-styles'
      }
    ],
    themeColor: '#6da852'
  },
  'debt.com': {
    logo: dcomlogo,
    url: 'https://www.debt.com/?utm_source=loancomparison&utm_campaign=loancomparelogo',
    company: 'Debt.com',
    copyright: '© 2022 Debt.com, LLC. All Rights Reserved',
    address: '5769 W. Sunrise Blvd. Plantation, FL 33313',
    phoneScreen: dcomphoneScreen,
    credibility: [
      {
        id: 'BBBLogo',
        logo: BBBLogo,
        link:
          'https://www.bbb.org/us/fl/plantation/profile/credit-services/debtcom-llc-0633-90080459',
        alt: 'BBBLogo',
        target: '_blank',
        stylesClass: 'logo-styles'
      },
      { id: 'UWayLogo', logo: UWayLogo, link: '', alt: 'UWayLogo', target: '' },
      {
        id: 'GoDaddyLogo',
        logo: GoDaddyLogo,
        link:
          'https://seal.godaddy.com/verifySeal?sealID=VttdGalb6RNnHGweH1ZPwYmmYt3XSbYeXM2Jk90v88Poa2JxPmkvASdRAOnA',
        alt: 'Godaddy',
        target: '_blank',
        stylesClass: 'logo-styles'
      },
      {
        id: 'TPilotLogo',
        logo: TPilotLogo,
        link: 'https://www.debt.com/reviews/',
        alt: 'TPilotLogo',
        target: '_blank',
        stylesClass: 'logo-styles'
      }
    ],
    themeColor: '#6da852'
  },
  defaultHostname: {
    logo: '',
    url: '',
    company: '',
    copyright: '',
    address: '',
    phoneScreen: '',
    credibility: [
      {
        id: 'GoDaddyLogo',
        logo: GoDaddyLogo,
        link:
          'https://seal.godaddy.com/verifySeal?sealID=VttdGalb6RNnHGweH1ZPwYmmYt3XSbYeXM2Jk90v88Poa2JxPmkvASdRAOnA',
        alt: 'Godaddy',
        target: '_blank',
        stylesClass: 'logo-styles'
      }
    ],
    themeColor: '#6da852'
  }
};

const config = variants[currentDomain];

const ConfigContext = React.createContext({});

export { ConfigContext, config };
